
export default {
    props: ['facusId'],
    data() {
        return {
            dialogVisible: false,
            nav: 0,
            focus: '', //关注我的
            concern: '', //我关注的

            loading: false,
            fanPage: 1,
            more: false, //加载更多
            moreShow: false,
            containerWidth:'',
        }
    },
    methods: {
        dialog(val) {
            this.nav = val
            this.dialogVisible = true
            // console.log(this.nav);
            this.nav == 0 ? this.focusMe() : this.myFocus()
        },
        // 关注我的
        async focusMe(page = 1) {
            this.focus = [];
            this.fanPage = 1;
            this.loading = true
            let res = await this.$global.focusMe({ "page": page, "user_id": this.facusId })
            res.code = '200' ? (this.focus = res.data, this.loading = false) : []
            this.fanPage == this.focus.userList.last_page ? this.moreShow = false : this.moreShow = true
        },
        // 我关注的
        async myFocus() {

            this.concern = [];
            this.fanPage = 1;
            this.loading = true
            let res = await this.$global.myFocus({ "page": 1, "user_id": this.facusId })
            res.code = '200' ? (this.concern = res.data, this.loading = false) : []
            this.fanPage == this.concern.userList.last_page ? this.moreShow = false : this.moreShow = true
        },
        async focusOn(id, index,) {
            //关注用户
            if (this.facusId == this.$store.state.userInfo.userInfo.uid) {
                let res = await this.$global.doFollow({ "fid": id })
                if (this.nav == 0) res.code == '200' ? this.focus.userList.data[index].is_follow = 1 : ''
                if (this.nav == 1) res.code == '200' ? this.concern.userList.data[index].is_follow = 1 : ''
                this.$emit('childEvent')
            }
        },
        async unsubscribe(id, index,) {
            //取消关注用户
            if (this.facusId == this.$store.state.userInfo.userInfo.uid) {
                let res = await this.$global.unFollow({ "fid": id })
                if (this.nav == 0) res.code == '200' ? this.focus.userList.data[index].is_follow = 0 : ''
                if (this.nav == 1) res.code == '200' ? this.concern.userList.data[index].is_follow = 0 : ''
                this.$emit('childEvent')
            }
        },
        // 加载更多
        async getMore() {
            // 关注我的

            if (this.nav == 0) {
                this.more = true
                this.fanPage += 1
                let res = await this.$global.focusMe({ "page": this.fanPage, "user_id": this.facusId })
                res.code = '200' ? (this.focus.userList.data = this.focus.userList.data.concat(res.data.userList.data), this.more = false) : ''
                this.fanPage == this.focus.userList.last_page ? this.moreShow = false : ''
            } else if (this.nav == 1) {
                // 关注他人的
                this.more = true
                this.fanPage += 1
                let res = await this.$global.myFocus({ "page": this.fanPage, "user_id": this.facusId })
                res.code = '200' ? (this.concern.userList.data = this.concern.userList.data.concat(res.data.userList.data), this.more = false) : ''
                this.fanPage == this.concern.userList.last_page ? this.moreShow = false : ''
            }
        },
        jumpUser(id) {
            this.$router.push({ path: `/user/${id}` })
        }
    },
    mounted() {

    },
    watch: {
        nav(val) {
            val == 0 ? this.focusMe() : this.myFocus()
        }
    }
}
